import { render, staticRenderFns } from "./EmptyState.vue?vue&type=template&id=e1894c88"
import script from "./EmptyState.vue?vue&type=script&lang=ts"
export * from "./EmptyState.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports